import { render } from "./ClientSdaRemainder.vue?vue&type=template&id=355b910a&scoped=true"
import script from "./ClientSdaRemainder.vue?vue&type=script&lang=js"
export * from "./ClientSdaRemainder.vue?vue&type=script&lang=js"

import "./ClientSdaRemainder.vue?vue&type=style&index=0&id=355b910a&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355b910a"]])

export default __exports__